<template>
    <div>
        <p class="other-login-title">贝壳系统号登录 <i class="icon-close" @click="handleClose"></i></p>
        <p class="login-label">系统号</p>
        <input type="text" v-model.trim="ljCode"
            class="form-item-base login-input disable_num_arrow"
            :class="{'login-input--hasval': ljCode}"
            :maxlength="20"
            placeholder="请输入系统号"/>

        <p class="login-label u-mt16">密码</p>
        <input type="password" v-model.trim="password"
            class="form-item-base login-input"
            :class="{'login-input--hasval': password}"
            maxlength="30"
            @keydown.enter="doLogin"
            placeholder="请输入密码"/>

        <!-- 需要输入图形验证码 -->
        <div v-if="needInputCaptcha">
            <p class="login-label u-mt16">图形验证码</p>
            <div class="login-captcha-container">
                <input type="text" v-model.trim="captcha"
                   class="form-item-base login-input"
                   :class="{'login-input--hasval': captcha}"
                   :maxlength="6"
                   @keydown.enter="doLogin"
                   placeholder="请输入图形验证码"/>
                <img :src="captchaObj ? 'data:image/jpeg;base64,' + captchaObj.base64Data : ''" class="login-captcha" @click="changeCaptcha($event)"/>
            </div>
        </div>
        <p class="login-errmsg-container" v-if="validateMag && validateCode != MOBILE_PWD_FAIL_TOOMANY_TIMES">
            <span class="login-errmsg">
                {{validateMag}}，请前往 <a href="javascript:;" @click="navToMobileLogin" class="text-main">快捷登录</a>
            </span>
        </p>

        <a href="javascript:;" class="form-item-base login-btn u-mt16"
           :class="{'login-btn--active': !disabledLoginBtn}"
           @click="doLogin">
            <span v-if="isSubmitting">登录中...</span>
            <span v-else>登录</span>
        </a>

    </div>
</template>

<script>
    import axios from 'axios'
    import MobileLogin from './MobileLogin.vue'
    import ErrorCodeMixin from '../mixin/ErrorCodeMixin.vue'
    import UtilMixin from '../mixin/UtilMixin.vue'

    export default {
        components: { MobileLogin },
        mixins: [ErrorCodeMixin, UtilMixin],
        data: function() {
            return {
                ljCode: '',
                password: '',
                captcha: '',

                validateCode: 0,
                validateMag:'',
                needBindMobile: false,
                needInputCaptcha: true,    //需要输入验证码
                captchaObj: null,

                isSubmitting: false
            }
        },
        created: function() {
            this.changeCaptcha()
        },
        computed: {
            disabledLoginBtn: function() {
                return !this.ljCode ||
                        !this.password ||
                        (this.needInputCaptcha && !this.captcha) ||
                        this.isSubmitting
            }
        },
        methods: {
            doLogin: function() {
                if(this.disabledLoginBtn) return;

                this.isSubmitting = true

                let data = {
                    site: meta.site,
                    ljCode: this.ljCode,
                    password: this.password,
                    captchaKey: this.captchaObj.key,
                    captcha: this.captcha
                }
                if(this.needInputCaptcha) {     //需要输入验证码
                    data.captcha = this.captcha
                }
                //已绑定过职道帐号， 登录成功
                axios.post('/api/login/ljCode', null,{ headers:{
                    'content-type':'application/x-www-form-urlencoded;charset=utf-8'
                    },params:data}).then((response) => {
                    this.isSubmitting = false
                    if(response.data.code == 0) {   //验证成功， 发送成功消息
                        this.$emit('on-success', response.data);
                    } else {
                        this._setErrorInfo(response)
                        this.changeCaptcha()
                    }
                }).catch(({ response }) => {
                    this.isSubmitting = false

                    this._setErrorInfo(response)

                    this.changeCaptcha()
                })
            },
            loginSuccess: function(data) {
                this.$emit('on-success', data)
            },
            changeCaptcha: function() {
                axios.get('/api/login/captcha').then((res) => {
                    this.captchaObj = res.data
                })
            },
            handleClose: function(){
                this.$emit('on-close')
            },
            _setErrorInfo: function(response) {
                this.validateCode = response.data.code
                this.validateMag = response.data.message

                if(response.status ===  500) {
                    this.validateMag = '服务器异常'
                }
            },
            navToMobileLogin: function() {
                this.$emit('on-failure', this.validateCode)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// EmpNoLogin.vue?291a66eb